import { useEffect, useState } from "react";

/** mm:ss formatter - zero-padded, never negative. */
export function formatCallDuration(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const mins = Math.floor(safe / 60);
  const secs = safe % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

/**
 * Optional internal ticker. Pass `external` to bypass and just use the controlled value.
 * Increments once per second while `isConnected` is true.
 */
export function useCallDuration(isConnected: boolean, external?: number): number {
  const [internal, setInternal] = useState(0);

  useEffect(() => {
    if (external !== undefined) return;
    if (!isConnected) return;
    const id = setInterval(() => setInternal((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [isConnected, external]);

  return external ?? internal;
}
